import React, { useEffect } from "react";
import ReactDOM from "react-dom";

const GREEN = "#4CAF50";
const ANCHOR_ID = "flyins-success-toast-anchor";

function ToastView({ message, onDone }) {
  useEffect(() => {
    const id = setTimeout(onDone, 5000);
    return () => clearTimeout(id);
  }, [onDone]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "stretch",
        backgroundColor: "#FFFFFF",
        borderRadius: 8,
        border: "1px solid #DCDCDC",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
        overflow: "hidden",
        maxWidth: "min(480px, calc(100vw - 32px))",
        animation: "flyinsSuccessToastIn 0.28s ease-out",
      }}
    >
      <div
        style={{
          width: 5,
          flexShrink: 0,
          backgroundColor: GREEN,
          alignSelf: "stretch",
        }}
        aria-hidden
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 14,
          padding: "14px 20px 14px 16px",
          minHeight: 52,
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            backgroundColor: GREEN,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
          aria-hidden
        >
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 6L9 17l-5-5"
              stroke="#FFFFFF"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <span
          style={{
            fontFamily: "Inter, -apple-system, Arial, Helvetica, sans-serif",
            fontSize: 15,
            fontWeight: 500,
            color: "#333333",
            lineHeight: 1.45,
          }}
        >
          {message}
        </span>
      </div>
    </div>
  );
}

/**
 * Success toast: white card, green left bar, green check circle, dark gray text.
 * Auto-dismiss after 5s. Top-center.
 */
export function showSuccessToast(message) {
  if (typeof document === "undefined") return;

  const prev = document.getElementById(ANCHOR_ID);
  if (prev) {
    try {
      ReactDOM.unmountComponentAtNode(prev);
    } catch (e) {
      /* ignore */
    }
    prev.remove();
  }

  const anchor = document.createElement("div");
  anchor.id = ANCHOR_ID;
  anchor.setAttribute(
    "style",
    "position:fixed;top:24px;left:50%;transform:translateX(-50%);z-index:100000;pointer-events:none;"
  );
  document.body.appendChild(anchor);

  const cleanup = () => {
    try {
      ReactDOM.unmountComponentAtNode(anchor);
    } catch (e) {
      /* ignore */
    }
    if (anchor.parentNode) {
      anchor.parentNode.removeChild(anchor);
    }
  };

  ReactDOM.render(
    <ToastView message={message} onDone={cleanup} />,
    anchor
  );
}

export const SUCCESS_TOAST_MESSAGES = {
  shipmentCreated: "Shipment has been successfully created.",
  boxReceived: "Box has been successfully received.",
};
